require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/bundles/bundles.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/bundles/bundles.legacy.js
// module id = 700
// module chunks = 31